// https://router.vuejs.org/api/interfaces/routeroptions.html
import type { RouterConfig } from '@nuxt/schema'

const routes: RouterConfig['routes'] = () => [
  // 匹配页
  {
    path: '/',
    redirect: '/roomApp/audio'
  },
  // // 主播首页
  // {
  //   path: '/home',
  //   name: 'Home',
  //   component: () => import('@/pages/Home/index.vue')
  // },
  // // 我的资料页
  // {
  //   path: '/aboutme',
  //   name: 'Aboutme',
  //   component: () => import('@/pages/Aboutme/index.vue')
  // },
  // // 编辑个人资料页
  // {
  //   path: '/editProfile',
  //   name: 'EditProfile',
  //   component: () => import('@/pages/EditProfile/index.vue')
  // },
  // // 关注列表页
  // {
  //   path: '/userList',
  //   name: 'UserList',
  //   component: () => import('@/pages/Aboutme/UserList.vue')
  // },
  // 我的收入 主播功能线上不开放
  // {
  //   path: '/aboutme/myIncome',
  //   name: 'MyIncome',
  //   component: () => import('@/pages/Aboutme/MyIncome.vue')
  // },
  // 兑换  主播功能线上不开放
  // {
  //   path: '/aboutme/exchange',
  //   name: 'Exchange',
  //   component: () => import('@/pages/Aboutme/Exchange.vue')
  // },
  // 私聊列表
  // {
  //   path: '/chat',
  //   name: 'Chat',
  //   component: () => import('@/pages/Chat/index.vue')
  // },
  // // 私聊页
  // {
  //   path: '/chatPage',
  //   name: 'ChatPage',
  //   component: () => import('@/pages/Chat/ChatPage.vue')
  // },
  // // 充值页
  // {
  //   path: '/recharge',
  //   name: 'Recharge',
  //   component: () => import('@/pages/Recharge/index.vue')
  // },
  // // 充值结果页
  // {
  //   path: '/recharge/result',
  //   name: 'Result',
  //   component: () => import('@/pages/Recharge/Result.vue')
  // },
  // // 关于我们
  // {
  //   path: '/draftstatic/about',
  //   name: 'About',
  //   component: () => import('@/pages/Draftstatic/About.vue')
  // },
  // // 隐私
  // {
  //   path: '/draftstatic/privacy',
  //   name: 'Privacy',
  //   component: () => import('@/pages/Draftstatic/Privacy.vue')
  // },
  // // 直播页
  // {
  //   path: '/room/live',
  //   name: 'RoomLive',
  //   component: () => import('@/pages/Room/Live.vue')
  // },
  // // 语音房
  // {
  //   path: '/room/audio',
  //   name: 'RoomAudio',
  //   component: () => import('@/pages/Room/Audio.vue')
  // },
  // // 视频通话
  // {
  //   path: '/room/call',
  //   name: 'RoomCall',
  //   component: () => import('@/pages/Room/Call.vue')
  // },
  // // 短视频通话
  // {
  //   path: '/room/callShortVideo',
  //   name: 'CallShortVideo',
  //   component: () => import('@/pages/Room/CallShortVideo.vue')
  // },
  // // App视频通话
  // {
  //   path: '/roomApp/call',
  //   name: 'RoomAppCall',
  //   component: () => import('@/pages/RoomApp/Call.vue')
  // },
  // // App直播房
  // {
  //   path: '/roomApp/live',
  //   name: 'RoomAppLive',
  //   component: () => import('@/pages/RoomApp/Live.vue')
  // },
  // // App语音房
  {
    path: '/roomApp/audio',
    name: 'RoomAppAudio',
    component: () => import('@/pages/RoomApp/Audio.vue')
  }
  // // 匹配中
  // {
  //   path: '/match/matching',
  //   name: 'Matching',
  //   component: () => import('@/pages/Match/Matching.vue')
  // },
  // 开始直播  主播功能线上不开放
  // {
  //   path: '/live/liveStart',
  //   name: 'LiveStart',
  //   component: () => import('@/pages/Live/LiveStart.vue')
  // },
  // 结束直播  主播功能线上不开放
  // {
  //   path: '/live/liveEnd',
  //   name: 'LiveEnd',
  //   component: () => import('@/pages/Live/LiveEnd.vue')
  // },
  // 封面编辑  主播功能线上不开放
  // {
  //   path: '/live/posterEditor',
  //   name: 'PosterEditor',
  //   component: () => import('@/pages/Live/PosterEditor.vue')
  // },
  // 认证  主播功能线上不开放
  // {
  //   path: '/verify',
  //   name: 'Verify',
  //   component: () => import('@/pages/Verify/index.vue')
  // },
  // webView
  // {
  //   path: '/webView/:key',
  //   // path: '/webView',
  //   name: 'WebView',
  //   component: () => import('@/pages/WebView/index.vue')
  // }
]

export default <RouterConfig>{
  routes
}
